import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { FormattedMessage } from 'react-intl';

import { Pluggable } from '@folio/stripes/core';

const InventoryCustomFieldsSettings = ({ match }) => {
  return (
    <Pluggable
      type="inventory-templates"
      basePath={match.path}
      redirectTo="custom-fields-list"
    >
      <FormattedMessage id="ui-inventory.templatesPluginNotAvailable" />
    </Pluggable>
  );
};

InventoryCustomFieldsSettings.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default InventoryCustomFieldsSettings;
